import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconHeadsetRoundLine = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 5.887A6.113 6.113 0 0 0 5.887 12v.889a2.78 2.78 0 0 1 3.556 2.668v1.778a2.778 2.778 0 0 1-5.556 0V12a8.113 8.113 0 0 1 16.227 0v5.335a2.778 2.778 0 0 1-5.557 0v-1.778a2.778 2.778 0 0 1 3.557-2.668V12A6.113 6.113 0 0 0 12 5.887Zm6.114 9.654a.778.778 0 0 0-1.557.016v1.778a.778.778 0 0 0 1.557 0v-1.794Zm-12.227.905v-.89a.778.778 0 1 1 1.556 0v1.78a.778.778 0 0 1-1.556 0v-.89Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconHeadsetRoundLine);
export default Memo;
